module.exports = __webpack_public_path__ + "static/img/home11.4f3a998f.png";